import { render } from "./ImageUploadField.vue?vue&type=template&id=a180a3de"
import script from "./ImageUploadField.vue?vue&type=script&lang=js"
export * from "./ImageUploadField.vue?vue&type=script&lang=js"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__